export default {   
    wsmo0: { id: "1", name: "N/A" }, 
    wsmo1: { id: "2", name: "MCPS" }, 
    wsmo2: { id: "3", name: "NON-MCPS" }, 
};
